import router from "@/router";
import axios from "axios";

const statusMap = {
    // response 상태값
    401: {
        title: "로그인 정보 오류",
        message:
            "로그인 세션이 만료되었거나 인증 정보가 올바르지 않습니다.\n로그인 페이지로 이동하여 다시 로그인해 주시기 바랍니다.",
        redirect: "error",
        type: "fail",
    },
    403: {
        title: "접근 권한 오류",
        message:
            "로그인 세션이 만료되었거나 존재하지 않아 해당 페이지에 접근할 수 없습니다.\n로그인 후 이용해주시기 바랍니다.",
        redirect: "error",
        type: "warn",
    },
    404: {
        title: "요청 페이지 오류",
        message: "요청하신 페이지를 찾을 수 없습니다.\n홈페이지로 돌아가 다시 이용해 주세요.",
        redirect: "error",
        type: "warn",
    },
    500: {
        title: "서버 내부 오류가 발생했습니다.",
        message:
            "현재 웹사이트에 기술적인 문제가 발생했습니다.\n불편을 드려 죄송합니다.\n잠시 후 다시 이용해 주시기 바랍니다.",
        redirect: "error",
        type: "fail",
    },
    502: {
        title: "시스템 점검중입니다.",
        message:
            "현재 시스템 점검중입니다.\n불편을 드려 죄송합니다.\n잠시 후 다시 이용해 주시기 바랍니다.",
        redirect: "error",
        type: "guide",
    },
    503: {
        title: "시스템 점검중입니다.",
        message:
            "현재 시스템 점검중입니다.\n불편을 드려 죄송합니다.\n잠시 후 다시 이용해 주시기 바랍니다.",
        redirect: "error",
        type: "guide",
    },
    406: {
        message: "",
        redirect: "dashboard",
    },
    // 사용자가 정의한 상태값
    1001: {
        title: "회원가입이 완료되었습니다.",
        message:
            "사이버 보안 취약점 정보 포털에 가입해 주셔서 감사합니다.\n제조사로 가입하신 회원은 관리자 승인 후 로그인하실 수 있습니다.",
        redirect: "error",
        type: "success",
    },
    1002: {
        title: "회원가입에 실패했습니다.",
        message:
            "회원가입 처리 중 문제가 발생했습니다.\n불편을 드려 죄송합니다.\n잠시 후 다시 이용해 주시기 바랍니다.",
        redirect: "error",
        type: "fail",
    },
    1003: {
        title: "요청하신 작업이 정상적으로 완료되지 않았습니다.",
        message:
            "서비스 이용 중 일시적인 오류가 발생하였습니다.\n불편을 드려 죄송합니다.\n잠시 후 다시 이용해 주시기 바랍니다.",
        redirect: "error",
        type: "fail",
    },
    1004: {
        title: "접수가 완료되었습니다.",
        message:
            "등록하신 내용이 정상적으로 접수되었습니다.\n신고 접수 내역은 취약점 신고 조회에서,\n패치 접수 내역은 취약점 패치 관리에서 확인하실 수 있습니다.",
        redirect: "error",
        type: "success",
    },
};

const api = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    withCredentials: true,
    withXSRFToken: true,
});

api.interceptors.response.use(
    (res) => res,
    async (err) => {
        // 1. 아예 응답이 없음 (네트워크 단절, 서버 다운 등)
        if (!err.response) {
            setErrorSession(500);
            return;
        }
        const status = err?.response?.status;

        const currentRouteName = router.currentRoute.value.name;

        if (currentRouteName === "dashboard") {
            return Promise.reject(err);
        }

        console.clear();
        sessionStorage.clear();
        localStorage.clear();

        setErrorSession(status);

        return Promise.reject(err);
    }
);

const setErrorSession = async (status, addMsg) => {
    const info = statusMap[status] || statusMap[500];
    if (info.redirect === "error") {
        sessionStorage.setItem("errorType", info.type);
        sessionStorage.setItem("errorTitle", info.title);
        let message = info.message;
        if (addMsg !== undefined) {
            message += `\n(${addMsg})`;
        }
        sessionStorage.setItem("errorMsg", message);
    }
    // 중복 이동 방지
    if (router.currentRoute.value.name !== info.redirect) {
        await router.push({ name: info.redirect });
    }
};

api.setErrorSession = setErrorSession;
export default api;
